import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import { createTV } from 'tailwind-variants';

import { nexusThemeVariables } from '../styles/theme';

function extractKeys(prefix: string): string[] {
	return Object.keys(nexusThemeVariables)
		.filter((key) => key.startsWith(prefix) && !key.includes('--'))
		.map((key) => key.substring(prefix.length + 1));
}

/**
 * Configuration for tailwind-merge
 * @see https://github.com/dcastil/tailwind-merge/blob/v3.1.0/docs/configuration.md
 */
type MergeConfig = Parameters<typeof extendTailwindMerge>[0];
const twMergeConfig: MergeConfig = {
	extend: {
		/** @see https://github.com/dcastil/tailwind-merge/blob/v3.1.0/docs/configuration.md#theme */
		theme: {
			text: extractKeys('text'),
			color: extractKeys('color'),
			radius: extractKeys('rounded'),
		},
	},
} as const;

/**
 * Extended tailwind-merge configuration with custom variables
 */
const twMerge = extendTailwindMerge(twMergeConfig);

/**
 * Extended tailwind-variants configuration with twMerge
 * @see https://www.tailwind-variants.org/docs/config
 */
export const tv = createTV({ twMergeConfig });

/**
 * Combines class names and resolves Tailwind CSS conflicts
 * @param inputs - Array of class values to be combined
 * @returns Combined and normalized class string with resolved conflicts
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
